import { Close, Inbox, Info, Mail, X } from "@mui/icons-material";
import {
  Alert,
  AppBar,
  Box,
  Button,
  CssBaseline,
  Divider,
  Drawer,
  FormControlLabel,
  FormGroup,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Snackbar,
  SnackbarCloseReason,
  Switch,
  ToggleButton,
  Toolbar,
  Typography,
} from "@mui/material";
import { closeSnackbar, SnackbarKey, useSnackbar, VariantType } from "notistack";
import { SyntheticEvent, useState } from "react";
import VideoPlayer from "./VideoPlayer";



export default function Main({connectionId, abortState, setConnected}: {connectionId: string, abortState: (state: boolean) => void, setConnected: (state: boolean) => void}) {
  return (
    <VideoPlayer localConnectionId={connectionId} abortState={abortState} setMainAppConnection={setConnected} />
  );
}
